import { DefaultFontStyles } from './DefaultFontStyles';
import { FontWeights } from './fonts';
export var DefaultFontSizes = {
    tiny: '1rem',
    xSmall: '1.2rem',
    small: '1.3rem',
    medium: '1.4rem',
    large: '1.6rem',
    xLarge: '1.8rem',
    xxLarge: '2rem',
    xxxLarge: '3rem',
    mega: '4rem'
};
export var DefaultFontFamilies = {
    default: DefaultFontStyles.medium.fontFamily,
    monospace: 'Menlo, Monaco, "Courier New", monospace'
};
export var DefaultFontWeights = {
    regular: FontWeights.regular,
    light: FontWeights.light,
    semibold: FontWeights.semibold,
    bold: FontWeights.bold
};
export var DefaultFontTypes = {
    default: {
        fontFamily: 'default',
        fontSize: 'medium',
        fontWeight: 'default'
    },
    disabled: {},
    caption: {
        fontSize: 'xSmall'
    },
    h1: {
        fontSize: 'mega',
        fontWeight: 'light'
    },
    h2: {
        fontSize: 'xxxLarge',
        fontWeight: 'light'
    },
    h3: {
        fontSize: 'xxLarge',
        fontWeight: 'light'
    },
    h4: {
        fontSize: 'xLarge',
        fontWeight: 'light'
    },
    h5: {
        fontSize: 'large',
        fontWeight: 'light'
    }
};
export var DefaultTypography = {
    families: DefaultFontFamilies,
    sizes: DefaultFontSizes,
    weights: DefaultFontWeights,
    types: DefaultFontTypes
};
//# sourceMappingURL=DefaultTypography.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/styling/lib/styles/DefaultTypography.js
// module id = 161
// module chunks = 0